import React, { useState, useEffect } from 'react';
import { AreaMap } from '@ant-design/maps';
import { cloneDeep } from 'lodash';
import GeoData from './geoData.json';
import NoData from '../../custom-components/NoData';
export const GrtMap = (props) => {
  const {
    field,
    setColor,
    labelField,
    labelFontSize,
    labelColor,
    tooltipItems,
    businessData,
    minZoom,
    maxZoom,
    tooltipTitleText,
  } = props;

  const [data, setData] = useState([]);

  const defalutConfig = {
    map: {
      type: 'mapbox',
      style: 'blank',
      center: ['116.405285', '39.904989'],
      minZoom: minZoom / 1,
      maxZoom: maxZoom / 1,
      dragPan: false,
      doubleClickZoom: false,
      interactive: false,
    },
    source: {
      data,
      parser: {
        type: 'geojson',
      },
    },
    autoFit: true,
    color: {
      field,
      value: setColor || [
        'rgb(239,243,255)',
        'rgb(189,215,231)',
        'rgb(107,174,214)',
        'rgb(49,130,189)',
        'rgb(8,81,156)',
      ],
      scale: {
        type: 'quantile',
      },
    },
    style: {
      opacity: 1,
      stroke: 'rgb(93,112,146)',
      lineWidth: 0.6,
      lineOpacity: 1,
    },
    state: {
      active: true,
    },
    label: {
      visible: true,
      field: labelField,
      style: {
        fill: labelColor,
        opacity: 0.8,
        fontSize: labelFontSize,

        textAllowOverlap: false,
        padding: [5, 5],
      },
    },
    tooltip: {
      title: tooltipTitleText,
      items: tooltipItems,
    },
  };

  // const asyncFetch = async () => {
  //   let res = await fetch('https://lowcode.grtcloud.net/static_main/china_province.json');
  //   let json = await res.json();
  //   return json;
  // };

  useEffect(() => {
    console.log(businessData, 'loaded');
    // asyncFetch().then((json) => {
    let data = cloneDeep(GeoData);
    if (businessData && businessData.length > 0) {
      data.features.forEach((v) => {
        v.properties.value = 0;
        businessData.forEach((vs) => {
          if (v.properties.adcode === vs.adcode) {
            v.properties.value = vs.value;
          }
        });
      });
      setData(data);
    }

    // });
  }, [businessData]);

  return businessData.length > 0 ? <AreaMap {...defalutConfig} /> : <NoData></NoData>;
};
